import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import '../styles/AuthPages.css';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [emailSent, setEmailSent] = useState('');

  // ✅ Handle forgot password submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await authApi.forgotPassword({ email });

      if (response.success) {
        setSuccess(true);
        setEmailSent(email);
        setEmail('');
        // Redirect to reset password after 5 seconds
        setTimeout(() => {
          navigate('/login');
        }, 5000);
      } else {
        setError(response.message || 'Failed to send reset link. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container forgot-password-page">
        <div className="auth-card">
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Reset Link Sent!</h2>
            <p>
              A password reset link has been sent to <strong>{emailSent}</strong>
            </p>
            <p className="email-info">
              Check your email inbox (and spam folder) for the reset link.
              The link will expire in 1 hour.
            </p>
            <button 
              className="btn-primary"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container forgot-password-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forgot Your Password?</h1>
          <p>Enter your email address and we'll send you a reset link.</p>
        </div>

        {error && (
          <div className="alert alert-danger">
            <span className="alert-icon">⚠️</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your registered email"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Remember your password?{' '}
            <button
              type="button"
              className="link-button"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </p>
        </div>
      </div>

      <div className="auth-info">
        <h3>💡 Tips</h3>
        <ul>
          <li>Check your email inbox for the reset link</li>
          <li>If you don't see it, check your spam folder</li>
          <li>Reset links expire after 1 hour</li>
          <li>Contact support if you need help</li>
        </ul>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
